import { Text } from "@marketplace/ui";
import { MdCheckCircle } from "react-icons/md";

type StatusTrackerItemProps = {
  status: {
    key: string;
    label: string;
  };
  isCompleted: boolean;
  getStatusDate: (statusKey: string) => string;
  showConnector: boolean;
};

export const StatusTrackerItem = ({
  status,
  isCompleted,
  getStatusDate,
  showConnector
}: StatusTrackerItemProps) => {
  return (
    <div className="w-[calc(33.333%-1rem)] flex flex-col items-center relative">
      {/* Icon */}
      <div className="relative z-10 mb-1">
        {isCompleted ? (
          <MdCheckCircle size={24} className="text-noble-blue-500" />
        ) : (
          <MdCheckCircle size={24} className="text-fjord-grey-100" />
        )}
      </div>

      {/* Label */}
      <div
        className={`text-center space-y-1 ${isCompleted ? "text-fjord-grey-500" : "text-fjord-grey-100"}`}
      >
        <Text type="heading" size="xxs" weight="bold">
          {status.label}
        </Text>
        <Text size="s">{getStatusDate(status.key)}</Text>
      </div>

      {/* Horizontal dashed line to next item */}
      {showConnector && (
        <div
          className={`absolute top-[calc(30%-8px)] left-[150px] w-[50px] border-[2px] border-dashed ${isCompleted ? "border-noble-blue-300" : "border-gray-300"}`}
          style={{ zIndex: 0 }}
        />
      )}
    </div>
  );
};
